export const normalizeExcludeTermText = (value: unknown) => String(value ?? "").trim().replace(/\s+/g, " ");

export const normalizeExcludeTermKey = (value: unknown) => normalizeExcludeTermText(value).toLocaleLowerCase("ko-KR");

const splitExcludeTermValues = (value: unknown): unknown[] => {
  const source = Array.isArray(value) ? value : [value];
  return source.flatMap((item) => (Array.isArray(item) ? [] : String(item ?? "").split(/[,\n]/)));
};

export const normalizeExcludeTerms = (value: unknown): string[] => {
  const byKey = new Map<string, string>();
  splitExcludeTermValues(value).forEach((rawValue) => {
    const term = normalizeExcludeTermText(rawValue);
    if (!term) return;
    const key = normalizeExcludeTermKey(term);
    if (!byKey.has(key)) byKey.set(key, term);
  });
  return Array.from(byKey.values());
};
